import { HttpHandler } from 'msw';
import { eInvoicingHandlers } from './eInvoicingHandlers';

export const handlersMap: Record<string, HttpHandler[]> = {
  eInvoincing: eInvoicingHandlers,
};
